<template>
  <div class="home">
    <transition name="slide-fade" mode="out-in">
      <div id="loading-screen" :class="{isMounted: isMounted}" v-if="!mapLoaded">
        <div class="loading-text">Chargement des patinoires</div>
        <scale-loader color="#fff" height="30px" width="5px"></scale-loader>
      </div>
    </transition>

    <div id="map-container">
      <div id="map" ref="googleMap" :class="{ blurred: isBlurred }"></div>
      <div id="geocoder" class="geocoder" :class="{ blurred: isBlurred }"></div>
    </div>

    <md-speed-dial
      class="menu-icons"
      md-event="click"
      md-direction="bottom"
      :class="{ blurred: isBlurred }"
    >
      <md-speed-dial-target class="md-primary">
        <md-icon class="md-morph-initial">menu</md-icon>
        <md-icon class="md-morph-final">close</md-icon>
      </md-speed-dial-target>

      <md-speed-dial-content>
        <md-button class="md-icon-button md-raised md-primary" @click="localizeUser(false)">
          <md-icon>my_location</md-icon>
        </md-button>

        <router-link to="/ajouter">
          <md-button class="md-icon-button md-raised md-primary">
            <md-icon>add</md-icon>
          </md-button>
        </router-link>

        <router-link to="/commentaires">
          <md-button class="md-icon-button md-raised md-primary">
            <md-icon>question_answer</md-icon>
          </md-button>
        </router-link>

        <router-link to="/credits">
          <md-button class="md-icon-button md-raised md-primary">
            <md-icon>info</md-icon>
          </md-button>
        </router-link>
      </md-speed-dial-content>
    </md-speed-dial>

    <transition name="slide-fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <md-dialog :md-active.sync="showNewRinkDialog">
      <md-dialog-title>Ajouter une patinoire</md-dialog-title>

      <md-dialog-content>
        <md-field>
          <label for="last-name">Nom</label>
          <md-input
            name="last-name"
            id="last-name"
            autocomplete="family-name"
            v-model="form.name"
            :disabled="sending"
          />
        </md-field>
        <md-field>
          <label>Lat</label>
          <md-input v-model="form.lat" :disabled="sending" />
        </md-field>
        <md-field>
          <label>Lng</label>
          <md-input v-model="form.lng" :disabled="sending" />
        </md-field>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeNewRinkDialog"
          >Annuler</md-button
        >
        <md-button class="md-primary">Ajouter</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<style>
/* a {
  text-decoration: none !important;
  color: #fff !important;
} */

.home {
  width: 100%;
  height: 100%;
}

#loading-screen {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  height: -webkit-fill-available;
  background-image: linear-gradient(120deg, #448aff 0%, #0D56D4 100%);
  z-index: 100;
}
#loading-screen div {
  opacity: 0;
  transform: translate3D(0px, 30px, 0);
  transition: 0.4s;
  transition-delay: 0.6s;
}
#loading-screen.isMounted div {
  opacity: 1;
  transform: translate3D(0px, 0px, 0);
}
#loading-screen div.loading-text {
  transition-delay: 0.4s;
}
.loading-text {
  color: #fff;
  font-size: 3em;
  line-height: 0.9em;
  max-width: 200px;
  margin-bottom: 50px;
  text-align: center;
}

#map-container {
  position: relative;
  overflow: hidden;
  height: 100vh;
  height: -webkit-fill-available;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
#map {
  height: 100vh;
  height: -webkit-fill-available;

  border-top-left-radius: 0px;
  border-top-right-radius: 0px;

  /* Fix border radius on Safari */
  mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC);

  transition: filter 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.refMarker {
  width: 18px;
  height: 18px;
  /* background: url('../assets/marker-red.png');
  background-size: contain; */
  border-radius: 100%;
  background: #8a99a2;
  border: 2px solid #fff;
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.refMarker.rink-open {
  width: 22px;
  height: 22px;
  border: 3px solid #fff;
  background: #09f;
  z-index: 2;
}
.refMarker.rink-closed {
  background: #bc5247;
}

.refCurrentLoc {
  width: 100px;
  height: 100px;
  background: #09f;
  border-radius: 100%;
  opacity: 0;
  z-index: 0;

  animation: currentLocation 4s infinite;
}

@keyframes currentLocation {
  0% {
    width: 80px;
    height: 80px;
    opacity: 0;
  }
  10% {
    opacity: 0.2;
  }
  70% {
    opacity: 0.2
  }
  100% {
    width: 150px;
    height: 150px;
    opacity: 0;
  }
}

.blurred {
  filter: blur(4px);
}

.menu-icons {
  display: flex;
  width: auto;
  flex-direction: column;
  position: fixed;
  top: 20px;
  right: 20px;
  align-items: center;
  z-index: 99;

  transition: filter 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.menu-icons .md-button {
  margin-left: 0;
  margin-right: 0;
}

.geocoder {
  position: absolute;
  width: calc(100% - 120px);
  max-width: 400px;
  left: 20px;
  top: 22.5px;
  z-index: 99;

  transition: filter 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.mapboxgl-ctrl-geocoder {
  min-width: 100%;
  font-family: "Staatliches", cursive;
}

.md-dialog {
  width: 450px;
}
.md-field {
  font-family: "Montserrat", sans-serif;
  margin-bottom: 0 !important;
}
.button-right {
  float: right;
}

@media only screen and (max-width: 600px) {
  #map-container {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  #map {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
}

</style>

<script>
import firebase from "firebase/app";
import "firebase/database";
import mapboxgl from "mapbox-gl/dist/mapbox-gl.js";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import { EventBus } from "../main";
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

const COORDS_MTL = { lat: 45.501689, lng: -73.567256 };

export default {
  name: "home",
  components: {
    ScaleLoader
  },
  data: () => ({
    isMounted: false,
    initialized: false,
    mapLoaded: false,
    showNewRinkDialog: false,
    sending: false,
    google: null,
    map: null,
    form: {
      name: null,
      lat: null,
      lng: null
    }
  }),
  computed: {
    homeIsBackground: function() {
      return this.$route.name != "Home";
    },
    isBlurred: function() {
      return this.homeIsBackground || !this.initialized;
    }
  },
  watch: {
    homeIsBackground: function(val) {
      if (val == false) {
        this.map.easeTo({ pitch: 0, zoom: 14 });
      }
    }
  },
  mounted() {
    this.isMounted = true;
    this.initializeMap();

    if (EventBus.initialized) {
      this.setInitialized();
    } else {
      EventBus.$on("initialized", this.setInitialized);
    }
  },
  beforeDestroy() {
    EventBus.$off("initialized");
  },
  methods: {
    setInitialized() {
      this.initialized = true;
      this.setMapLoaded();

      let rinks = EventBus.rinks;
      for (let rinkId in rinks) {
        this.addMarker(rinkId, rinks[rinkId]);
      }
    },
    setMapLoaded() {
      if (this.map.loaded()) {
        this.mapLoaded = true;
      } else {
        setTimeout(() => {this.setMapLoaded()}, 500);
      }
    },
    initializeMap() {
      const mapContainer = this.$refs.googleMap;

      mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
      this.map = new mapboxgl.Map({
        container: mapContainer,
        style: "mapbox://styles/kovalexis/ck3hu7fcl1cs81dowa11ks2pj",
        center: [COORDS_MTL.lng, COORDS_MTL.lat],
        zoom: 12
      });

      this.localizeUser(true);

      var geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        countries: 'ca',
        language: 'fr-CA',
        marker: null,
      });
      document.getElementById('geocoder').appendChild(geocoder.onAdd(this.map));
    },
    localizeUser(initialLocalize) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            var coords = new mapboxgl.LngLat(
              position.coords.longitude,
              position.coords.latitude
            );
            this.setMapCenter(coords, initialLocalize);
          },
          function() {
            // console.log("Error getting location");
          }
        );
      }
    },
    setMapCenter(coords, initialLocalize) {
      this.map.easeTo({ center: coords, zoom: 13 });

      if (initialLocalize) {
        let el = document.createElement("div");
        el.className = "refCurrentLoc";

        let marker = new mapboxgl.Marker(el)
          .setLngLat(coords)
          .addTo(this.map);
      }
    },
    mapReCenter(latlng) {
      let latLngObj = new mapboxgl.LngLat(latlng.lng, latlng.lat);
      this.map.easeTo({
        center: latLngObj,
        offset: [0, -(window.innerHeight / 4)],
        pitch: 60,
        zoom: 17
      });
    },
    addMarker(rinkId, rink) {
      if (rink.lng && rink.lat) {
        let el = document.createElement("div");
        let classes = "refMarker";
        el.addEventListener("click", () => this.markerClicked(rinkId, rink));

        if (rink.latest) {
          
          if (rink.latest.ouv === "1") {
            classes += " rink-open";
          } else {
            classes += " rink-closed";
          }
        }

        el.className = classes;
  
        let marker = new mapboxgl.Marker(el)
          .setLngLat([rink.lng, rink.lat])
          .addTo(this.map);
      } else {
      //  console.log("No coords for: " + rinkId);
      }
    },
    markerClicked(rinkId, rink) {
      this.mapReCenter({ lat: rink.lat, lng: rink.lng });
      setTimeout(() => {
        this.$router.push({ path: `/patinoires/${rinkId}` });
      }, 500);
    },
    closeNewRinkDialog() {
      this.showNewRinkDialog = true;
    },
    goTo(path) {
      this.$router.push({ path });
    }
  }
};
</script>
